const ISO_DATE = /^(\d{4})-(\d{2})-(\d{2})$/;

export function normalizeEvOfferDate(value: unknown): string | null {
  if (value instanceof Date) {
    if (!Number.isFinite(value.getTime())) return null;
    return value.toISOString().slice(0, 10);
  }
  if (typeof value !== "string") return null;
  const valueTrimmed = value.trim();
  const direct = ISO_DATE.exec(valueTrimmed);
  if (direct) {
    const parsedDate = new Date(`${valueTrimmed}T00:00:00.000Z`);
    return Number.isFinite(parsedDate.getTime()) && parsedDate.toISOString().slice(0, 10) === valueTrimmed ? valueTrimmed : null;
  }
  const parsed = new Date(valueTrimmed);
  if (!Number.isFinite(parsed.getTime())) return null;
  return parsed.toISOString().slice(0, 10);
}

export function formatEvOfferDate(value: unknown): string {
  const iso = normalizeEvOfferDate(value);
  if (!iso) return "Sin fecha";
  const match = ISO_DATE.exec(iso)!;
  return `${match[3]}/${match[2]}/${match[1]}`;
}
